import { CSSProperties, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export default function PageTitleComponent(props: Props) {
  return <h2 style={titleStyle}>{props.children}</h2>
}

const titleStyle: CSSProperties = {
  marginBottom: '16px',
}
